import { convertToAddonFieldType, formatEnumOptions } from 'automation-ui-action-features/object-type-properties/propertyUtils';
import { getObjectTypePropertyLabel } from 'automation-ui-references/object-type-properties/getObjectTypePropertyLabel';
import fieldTypeDefinitionToPropertyAdapter from 'automation-ui-action-features/action-outputs/utils/fieldTypeDefinitionToPropertyAdapter';
const convertTypeDefinitionToOptions = typeDefinition => {
  const {
    label,
    name,
    type,
    fieldType,
    options,
    referencedObjectType,
    externalOptions
  } = typeDefinition;
  return {
    text: getObjectTypePropertyLabel(name, label),
    value: name,
    fieldType: convertToAddonFieldType(type, fieldType),
    valueType: type,
    valueOptions: formatEnumOptions(options || []),
    referencedObjectType,
    externalOptions,
    propertyDefinition: fieldTypeDefinitionToPropertyAdapter(typeDefinition)
  };
};
export default convertTypeDefinitionToOptions;